/*
 * Linki zewnętrzne:
 * - linki do starego Instagrama marki (loliparadise_society, instagram.paradisesociety.com) -> @paradisesociety306
 *   (linki do Instagramów artystów w opisach produktów zostają bez zmian)
 * - każdy link do TikToka -> zawsze @paradisesociety306
 * - pozostałe linki zewnętrzne otwierają się od razu w nowej karcie,
 *   bez strony Shopify "Czy na pewno chcesz opuścić sklep?" (/url?q=...).
 *   Shopify przechwytuje kliknięcia w <a href> do obcych domen, więc adres
 *   przenosimy do data-fkx-href i otwieramy go sami przez window.open.
 * - linki do naszej domeny pod innym adresem niż bieżący (np. konto klienta -> www.paradisesociety.com
 *   oglądane z podglądu motywu) — też bez tej strony, w nowej karcie. Na żywej stronie konto jest
 *   w tej samej domenie, więc tam link zostaje zwykłym linkiem.
 */
(function () {
  var TIKTOK_URL = 'https://www.tiktok.com/@paradisesociety306';
  var INSTAGRAM_URL = 'https://www.instagram.com/paradisesociety306';
  var SITE_HOSTS = /(^|\.)paradisesociety\.com$|\.myshopify\.com$/i;

  function parse(href) {
    try {
      return new URL(href, document.baseURI);
    } catch (e) {
      return null;
    }
  }

  function isOtherOrigin(url) {
    return !!url && (url.protocol === 'http:' || url.protocol === 'https:') && url.origin !== location.origin;
  }

  function isExternal(url) {
    return isOtherOrigin(url) && !SITE_HOSTS.test(url.hostname);
  }

  // nasza domena, ale inny adres niż bieżąca strona
  function isOwnElsewhere(url) {
    return isOtherOrigin(url) && SITE_HOSTS.test(url.hostname);
  }

  function process(a) {
    var href = a.getAttribute('href');
    if (href === null) return;
    var url = parse(href);
    if (!url) return;
    var host = url.hostname.replace(/^www\./i, '').toLowerCase();

    // stary Instagram marki (konto, goły instagram.com i przekierowanie z naszej subdomeny) -> nowe konto
    if (
      (host === 'instagram.com' && /^\/(loliparadise_society\b.*)?$/i.test(url.pathname)) ||
      host === 'instagram.paradisesociety.com'
    ) {
      url = new URL(INSTAGRAM_URL);
    }

    if (host === 'tiktok.com' || host.slice(-11) === '.tiktok.com') url = new URL(TIKTOK_URL);

    // nasza domena pod innym adresem (np. konto klienta z podglądu motywu, którego podgląd nie obsługuje) —
    // jak link zewnętrzny; Shopify przechwytuje tu nawet zwykłe przejście w tej samej karcie
    if (a.hasAttribute('download') || !(isExternal(url) || isOwnElsewhere(url))) return;

    a.setAttribute('data-fkx-href', url.href);
    a.removeAttribute('href');
    a.setAttribute('role', 'link');
    if (!a.hasAttribute('tabindex')) a.setAttribute('tabindex', '0');
    a.style.cursor = 'pointer';
  }

  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches('a[href]')) process(root);
    root.querySelectorAll('a[href]').forEach(process);
  }

  function open(el) {
    window.open(el.getAttribute('data-fkx-href'), '_blank', 'noopener');
  }

  document.addEventListener('click', function (e) {
    var el = e.target.closest && e.target.closest('a[data-fkx-href]');
    if (!el) return;
    e.preventDefault();
    open(el);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target.closest && e.target.closest('a[data-fkx-href]');
    if (!el) return;
    e.preventDefault();
    open(el);
  });

  scan(document.documentElement);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.type === 'attributes') {
        process(m.target);
      } else {
        m.addedNodes.forEach(scan);
      }
    });
  }).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });
})();
